import React, { useState } from "react";
import { Link } from "react-router-dom";
import { lastKnownPlace } from "../../utils/members.util";
import { MemberAvatar } from "../Common/Avatar";
import ChevronRoundButton from "../Common/ChevronRoundButton";
import "./MemberHeader.css";
import {
    isTestMember,
    isVipMember,
    type MemberDataFirestoreRecord,
} from "@albertine/types";
import { MemberMarkers } from "@prototypes/member-markers/MemberMarkers";
import { EventEmitter } from "../../EventEmitter";
import { FormattedDateTime, FormattedTime } from "../Common/DateTime";
import { Flex } from "../Common/Flex";
import Label from "../Common/Label";
import Toggle from "../Common/Toggle";

type Props = {
    member: MemberDataFirestoreRecord | undefined;
    collapsed: boolean;
    showTopicFilter: boolean;
    toggleClicked: () => void;
};

const MemberHeader = function MemberHeader(props: Props) {
    const { member, collapsed, toggleClicked, showTopicFilter } = props;

    const [threadedChatChecked, setThreadedChatChecked] = useState<boolean>(true);

    const toggleThreadedChat = () => {
        const newValue = !threadedChatChecked;
        setThreadedChatChecked(newValue);
        EventEmitter.emit({
            name: "toggleThreadedChat",
            params: { enabled: newValue },
        });
    };

    const memberLastKnownPlace = member && lastKnownPlace(member);

    return (
        <Flex.Row justifyContent="space-between" className="member-header">
            <Flex.Row>
                {/* @ts-ignore we are using outdated libraries that use ReactNode instead of JSX.Element. */}
                <Link to={`/member/${member?.id}`}>
                    <Flex.Row gap="large">
                        <MemberAvatar memberId={member?.id} size="big" />

                        <Flex.Column gap="xsmall">
                            <Flex.Row gap="xsmall">
                                <Label.Large.Light>
                                    {member?.firstName} {member?.lastName}
                                </Label.Large.Light>
                                {member && (
                                    <MemberMarkers
                                        isTestMember={isTestMember(member)}
                                        isVipMember={isVipMember(member)}
                                    />
                                )}
                            </Flex.Row>

                            {member?.lastSeenAt && (
                                <Label.Small.Light.N60>
                                    Last seen{" "}
                                    <FormattedTime.Comparison
                                        timestamp={member.lastSeenAt}
                                    />
                                    {", "}
                                    <FormattedDateTime.PrettyTimestamp
                                        timestamp={member.lastSeenAt}
                                    />
                                    {memberLastKnownPlace
                                        ? ` in ${memberLastKnownPlace}`
                                        : null}
                                </Label.Small.Light.N60>
                            )}
                        </Flex.Column>
                    </Flex.Row>
                </Link>
            </Flex.Row>

            <Flex.Row gap="large" justifyContent="end">
                {showTopicFilter && (
                    <div>
                        <Flex.Row>
                            Filter by topic
                            <Toggle
                                className="member-header__filter-by-topic-toggle"
                                checked={threadedChatChecked}
                                onChange={toggleThreadedChat}
                            />
                        </Flex.Row>
                    </div>
                )}

                <ChevronRoundButton
                    state={collapsed ? "collapsed" : "expanded"}
                    direction="left-or-right"
                    onToggleClick={() => {
                        toggleClicked();
                    }}
                />
            </Flex.Row>
        </Flex.Row>
    );
};

export default MemberHeader;
